// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-tooltip {
  background-color: #fef7e5 !important;
  color: #000 !important;
}

.tooltip-content {
  width: 100%;
  max-width: 500px;
  padding-bottom: 10px;
  background-color: transparent !important;
  color: #000;
}
.tooltip-content h2 {
  font-size: 1.3rem;
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}
.tooltip-content h3 {
  font-size: 1rem;
  font-weight: bold;
  margin-top: 0.8rem;
  margin-bottom: 0.5rem;
}
.tooltip-content p {
  font-size: 0.8rem;
}

.mdi.size10 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.mdi.size10::before {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./packages/aiand-qa/frontend/src/assets/css/tooltip.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,sBAAA;AACF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,wCAAA;EACA,WAAA;AAEF;AAAE;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AAEJ;AACE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;AAIE;EACE,eAAA;AAFJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
